import { TrackedButton } from '@/components/button';
import { TRACKED_EVENT_NAME, TRACKED_EVENT_POSITION } from '@/constants';
import { cn } from '@lib/utils';

import { carouselNavLabel } from './constants';

export function NavArrow({
  direction,
  onClick,
  label,
  large = false,
  tabIndex,
}: {
  direction: 'prev' | 'next';
  onClick: () => void;
  label: string;
  large?: boolean;
  // 데스크탑 roving 캐러셀에선 -1(화살표 키로만 접근). 모바일은 미전달(기본 0).
  tabIndex?: number;
}) {
  return (
    <TrackedButton
      type="button"
      aria-label={label}
      label={carouselNavLabel(direction)}
      position={TRACKED_EVENT_POSITION.MAIN_CONTENT}
      eventName={TRACKED_EVENT_NAME.CLICK_BUTTON}
      gtagOptions={{ method: 'button' }}
      onClick={onClick}
      tabIndex={tabIndex}
      data-nav={direction}
      className={cn(
        'flex items-center justify-center text-white backdrop-blur-sm transition-colors',
        large
          ? 'size-[72px] rounded-[36px] bg-[rgba(246,247,254,0.29)] hover:bg-[rgba(246,247,254,0.45)]'
          : 'h-11 w-11 rounded-full bg-white/40 hover:bg-white/60',
      )}
    >
      <svg
        width={large ? 36 : 24}
        height={large ? 36 : 24}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d={direction === 'prev' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6'}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </TrackedButton>
  );
}
